module.exports = __webpack_public_path__ + "files/lepelletier.7da8893ba3170ea001a84e74edb16254.pdf";